import React from "react";
import { apiGet, getAgentUrl } from "./Utilities";
import Modal from 'react-bootstrap/Modal';
import { SetupInstructions } from "./Config";
import { Button } from "react-bootstrap";

import { Trans, withTranslation, WithTranslation } from "react-i18next";

class TeamDriveConnectionTest extends React.Component<WithTranslation> {
    state = {
        error: "",
        loginRequired: false,
        showModal: false
    };

    private testConnection = () => {
        const waitingForConnect = this.state.loginRequired || this.state.error !== '';

        apiGet('getLoginInformation').then(info => {
            this.setState({loginRequired: info.isLoginRequired, error: '' });
            return !info.isLoginRequired;
        }).catch(err => {
            this.setState({error: err.message, loginRequired: false});
            console.error(`Unable to connect to local TeamDrive instance, error was ${err.message}`);
            return false;
        }).then(connectionOk => {
            if (!connectionOk) {
                // no connection yet, check again in 5s
                setTimeout(this.testConnection, 5000);
            } else if (waitingForConnect) {
                // have connection now and didn't before, reload the page
                window.location.reload();
            }
        });
    };

    private closeModal = () => {
        this.setState({ showModal: false });
    };

    componentDidMount() {
        this.testConnection();
    }

    showInfo = () => {
        this.setState({showModal: true});
    };

    render() {
        const t = this.props.t;

        return (<>
            { (this.state.error === "") ? null : 
                <Trans i18nKey='errorTeamDriveNotRunning'>
                    <div className="alert alert-info">
                        To enable integration with TeamDrive, please ensure that TeamDrive is running and configured 
                        as described <Button className="inline-btn" variant="link" onClick={this.showInfo}>here</Button>.
                    </div> 
                </Trans>
            }
            { this.state.loginRequired &&
                <Trans i18nKey='userLoginRequired'>
                    <div className="alert alert-info">
                        Please login to your local TeamDrive client <a href={ getAgentUrl() } target="_blank" rel="noreferrer">here</a> to enable Microsoft-Teams
                        integration.
                    </div> 
                </Trans>
            }
            <Modal show={this.state.showModal} onHide={this.closeModal}>
                <Modal.Header closeButton>
                <Modal.Title>{t('Setup Instructions')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SetupInstructions></SetupInstructions>
                </Modal.Body>
            </Modal>
        </>);
    }

}
export default withTranslation()(TeamDriveConnectionTest);